import { pageAnchors } from 'components/page_detail'
import { ClubDetailSection } from '../types'

export const clubAnchors = [
  pageAnchors.about,
  pageAnchors.books,
  pageAnchors.hiw,
  pageAnchors.faq,
]

export const clubSections: ClubDetailSection[] = [
  {
    id: pageAnchors.about.id,
  },
  {
    id: pageAnchors.books.id,
    sectionProps: {
      title: 'Book club picks',
    },
  },
  {
    id: pageAnchors.hiw.id,
    sectionProps: {
      title: 'How book clubs work on Fable',
    },
  },
  {
    id: pageAnchors.faq.id,
    sectionProps: {
      title: 'Frequently Asked Questions',
    },
  },
]
